import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { EmbodimentClaimFeaturesModel } from '../embodiment-claim-features-model';
import type { EmbodimentClaimFeaturesState } from '../../types';

@injectable()
export class EmbodimentClaimFeaturesModelImpl extends AbstractModel<EmbodimentClaimFeaturesState> implements EmbodimentClaimFeaturesModel {
    protected _modelData: EmbodimentClaimFeaturesState = {
        claimFeatures: [],
        isLoading: false,
    };
}
